(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[75650],{

/***/ 17537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56362);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33794);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var Svg = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var BookmarkContainer = function(param) {
    var title = param.title, buttonTitle = param.buttonTitle, url = param.url, onClick = param.onClick, containerClass = param.containerClass, titleClass = param.titleClass, buttonClass = param.buttonClass;
    var label = buttonTitle || "Read more";
    var buttonClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button), buttonClass);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bookmarkContainer), containerClass),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Svg, {
                type: "bookMark",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bookmarkIcon)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title), titleClass),
                        children: title
                    }),
                    url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        path: url,
                        className: buttonClassName,
                        children: label
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: buttonClassName,
                        onClick: onClick,
                        children: label
                    })
                ]
            })
        ]
    });
};
BookmarkContainer.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
    buttonTitle: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    url: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    containerClass: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    titleClass: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    buttonClass: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (BookmarkContainer);


/***/ }),

/***/ 75650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_BookmarkCardSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/BookmarkContainer/index.jsx
var BookmarkContainer = __webpack_require__(17537);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./UI/sections/BookmarkCardSection/utils/bookmarkCardHelper.js


var getBookmarkCardProps = function(data) {
    var ref = (0,helper/* getDocumentFields */.OA)(data, [
        "title",
        "contentModules",
        "view", 
    ]), title = ref.title, contentModules = ref.contentModules, view = ref.view;
    var linkData = get_default()(contentModules, "[0]", {});
    var url = get_default()(linkData, "fields.url");
    return {
        title: title,
        view: view,
        url: url
    };
};

// EXTERNAL MODULE: ./UI/sections/BookmarkCardSection/styles.module.scss
var styles_module = __webpack_require__(40537);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/BookmarkCardSection/index.jsx






var BookmarkCardSection = function(param) {
    var sectionData = param.sectionData, pageType = param.pageType, handleOnCTAClick = param.handleOnCTAClick;
    var ref = getBookmarkCardProps(sectionData), title = ref.title, view = ref.view, url = ref.url;
    if (!title) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((styles_module_default()).bookmarkSection, (styles_module_default())[pageType], (styles_module_default())[view]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).contentWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookmarkContainer/* default */.Z, {
                title: title,
                url: url,
                onClick: !url ? handleOnCTAClick : undefined,
                containerClass: (styles_module_default()).bookmarkContainer,
                titleClass: (styles_module_default()).title
            })
        })
    });
};
BookmarkCardSection.propTypes = {
    sectionData: prop_types_default().instanceOf(Object).isRequired,
    pageType: (prop_types_default()).string.isRequired,
    handleOnCTAClick: (prop_types_default()).func
};
/* harmony default export */ var sections_BookmarkCardSection = (BookmarkCardSection);


/***/ }),

/***/ 33794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bookmarkContainer":"styles_bookmarkContainer___9jz1","bookmarkIcon":"styles_bookmarkIcon__uUF9l","content":"styles_content__xSQBh","title":"styles_title__ETUpi","button":"styles_button__oPcmj"};

/***/ }),

/***/ 40537:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__cfS9H","cards":"styles_cards__gKEZW","imageWrapper":"styles_imageWrapper__OHMp1","typeTitle":"styles_typeTitle__9GF08","greySection":"styles_greySection__MzdhH","callToAction":"styles_callToAction__S1d9D","threeColumnsCards":"styles_threeColumnsCards__tlfb5","twoColumnsCards":"styles_twoColumnsCards__yoIk_","textContent":"styles_textContent__Ni_7T","bookmarkSection":"styles_bookmarkSection__YGQ5O","contentWrapper":"styles_contentWrapper__MDBYq","devops-development-services":"styles_devops-development-services__p92Yr","firstSectionView":"styles_firstSectionView__BXeTF","title":"styles_title__cKLrQ","secondSectionView":"styles_secondSectionView__op1AM","cloud-based-app-development-services":"styles_cloud-based-app-development-services__PHsSt","bookmarkContainer":"styles_bookmarkContainer__kJTGC"};

/***/ })

}]);